/**
 * Product card hover video.
 * Plays a product's video (muted, looping) while the card media is hovered,
 * and pauses/rewinds it on leave. Uses event delegation so cards added later
 * (ajax filtering, load more, recommendations) work without re-initialising.
 */
(function () {
  var MEDIA_SELECTOR = ".m-product-card--show-hover-video .m-product-card__media";
  var WRAPPER_SELECTOR = ".m-product-card__hover-video";

  // Hover has no meaning on touch devices, and respect reduced motion.
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function getWrapper(media) {
    return media.querySelector(WRAPPER_SELECTOR);
  }

  function play(media) {
    var wrapper = getWrapper(media);
    if (!wrapper) return;
    var video = wrapper.querySelector("video");
    if (!video) return;

    if (!video.dataset.hoverVideoBound) {
      video.dataset.hoverVideoBound = "true";
      video.addEventListener("playing", function () {
        wrapper.classList.add("is-playing");
      });
      video.addEventListener("error", function () {
        wrapper.classList.remove("is-playing");
      });
    }

    var promise = video.play();
    if (promise && typeof promise.catch === "function") {
      promise.catch(function () {
        // Autoplay blocked or media not ready: keep showing the image.
        wrapper.classList.remove("is-playing");
      });
    }
  }

  function stop(media) {
    var wrapper = getWrapper(media);
    if (!wrapper) return;
    var video = wrapper.querySelector("video");
    if (!video) return;

    wrapper.classList.remove("is-playing");
    video.pause();
    if (video.readyState > 0) {
      try {
        video.currentTime = 0;
      } catch (e) {
        /* ignore */
      }
    }
  }

  function isLeaving(event, media) {
    return !event.relatedTarget || !media.contains(event.relatedTarget);
  }

  document.addEventListener("mouseover", function (event) {
    var media = event.target.closest && event.target.closest(MEDIA_SELECTOR);
    if (!media) return;
    // Only fire once when entering the media block, not on every child.
    if (event.relatedTarget && media.contains(event.relatedTarget)) return;
    play(media);
  });

  document.addEventListener("mouseout", function (event) {
    var media = event.target.closest && event.target.closest(MEDIA_SELECTOR);
    if (!media) return;
    if (!isLeaving(event, media)) return;
    stop(media);
  });

  // Pause everything when the tab is hidden.
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) return;
    document.querySelectorAll(MEDIA_SELECTOR).forEach(stop);
  });
})();
